import script from "./security-event-dispose.vue?vue&type=script&setup=true&lang=ts"
export * from "./security-event-dispose.vue?vue&type=script&setup=true&lang=ts"

import "./security-event-dispose.vue?vue&type=style&index=0&id=d8e05596&scoped=true&lang=scss"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d8e05596"]])

export default __exports__